import DefaultPropsProvider from '@mui/material/DefaultPropsProvider';
import { useCallback, useMemo, useRef } from 'react';

import { IslandPortalHost } from './island-portal-host.jsx';
import { createIslandPortalDefaultProps } from './island-portal-theme.js';
import { resolveIslandPortalContainer } from './resolve-island-portal-container.js';

/**
 * @param {{
 *   children: import('react').ReactNode,
 *   islandRootElement?: Element | null,
 * }} props
 */
export function IslandPortalThemeLayer({ children, islandRootElement = null }) {
	const portalHostRef = useRef(null);

	const getPortalContainer = useCallback(() => {
		const portalHost = portalHostRef.current;

		if (portalHost instanceof HTMLElement) {
			return portalHost;
		}

		return resolveIslandPortalContainer(islandRootElement);
	}, [islandRootElement]);

	const portalDefaultProps = useMemo(
		() => createIslandPortalDefaultProps(getPortalContainer),
		[getPortalContainer],
	);

	return (
		<DefaultPropsProvider value={portalDefaultProps}>
			{children}
			<IslandPortalHost ref={portalHostRef} />
		</DefaultPropsProvider>
	);
}
